import * as React from "react"

const SkipForward = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      d="M12 3h1v10h-1V3ZM9.11 8 4 11.2V4.8L9.11 8ZM3 12.1V3.9c0-.4.43-.63.77-.42l6.55 4.1a.5.5 0 0 1 0 .84l-6.55 4.1A.5.5 0 0 1 3 12.1Z"
    />
  </svg>
)

export default SkipForward
